<div class="container p-4 px-xl-0 registration-container">
  <h1 class="text-uppercase">{{'registration.success.header' | translate }}</h1>
  <p class="mb-4"> {{'registration.success.headerText' | translate }}</p>

  <div class="row gap-3 py-2">
    <button class="col-120 col-lg-auto btn btn-secondary" (click)="toHomepage()">
      {{'registration.success.toHomepage' | translate }}
    </button>
    <button class="col-120 col-lg-auto btn btn-primary" (click)="login()">
      {{'registration.success.toLogin' | translate }}
    </button>
  </div>
</div>
